import { useDocumentTitle } from 'usehooks-ts'

import i18n from 'modules/core/lib/i18n'

import EmployeeCollectionPage from './EmployeeCollectionPage'

const EmployeesListPage = () => {
  useDocumentTitle(i18n.t('employees.title'), {
    preserveTitleOnUnmount: false,
  })

  return <EmployeeCollectionPage />
}

export default EmployeesListPage
